export default {
  messages: {
    gather:
      'A informação de assinatura dos documentos está a ser recolhida da Blockchain.',
    processing: 'A processar a sua informação',
  },
  tooltip: 'Opens in a new window',
  loader: 'Por favor aguarde',
  intercom: {
    start:
      'Olá, está a ter dificuldades a utilizar os documentos de ID na sua carteira digital?',
    compatible:
      'Olá, parece que não está num browser compatível com a validação do TSP WalliD. Já experimentou abrir o link no Chrome ou Firefox?',
    wallet:
      'Olá, parece que não tem uma carteira digital criada ainda. Carregue no botão em baixo ou pergunte-me o que precisar',
    button:
      'Olá, parece que o botão que tentou carregar não está a funcionar. Deixe-me ver o que posso fazer para ajudar.',
    metamask:
      'Olá, parece que não tem uma carteira digital criada ainda. Precisa de ajuda para a configurar?',
    login: 'Olá, parece que não está logado na sua carteira digital ainda.',
    stored:
      'Olá, está a ter dificuldades a utilizar os documentos de ID na sua carteira digital?',
    noID:
      'Olá, parece que não tem um documento ID guardado na sua carteira digital. Carregue no botão "guardar identidade" ou fale comigo caso tenha alguma dúvida',
    authorize:
      'Olá, precisa de autorizar o acesso à sua carteira digital no plug-in da sua carteira. DIga-me se precisar de apoio.',
    sign:
      'Olá, precisa de assinar o documento no botão no canto inferior direito da janela para concluir o processo de assinatura',
    invalid:
      'Olá, parece que houve um problema a validar o seu documento ID. Tem a certeza que tem um válido armazenado na sua carteira digital?',
    failSign:
      'Olá, parece que houve um problema com a assinatura do documento. Deixe-me ver o que posso fazer para ajudar',
  },
  errors: {
    revoked: 'O certificado do documento de identidade expirou.',
    invalid: 'TSP falhou a validar a identidade.',
    identity: 'TSP falhou a ir buscar a sua identidade.',
    expired: 'TSP falhou a validar a identidade porque a sua sessão expirou',
    decrypt: 'Falhou a decifrar a sua identidade! Tente novamente!',
    token: 'TSP falhou a assinatura devido a um token não autorizado',
    noMetamask: [
      'Não foi detectado uma carteira digital. Para continuar ligue-se com o ',
    ],
    loggedOut:
      'Não está conectado à sua carteira. Faça login na sua carteira no pop-up apresentado pela sua carteira digital.',
    noWallet: 'Parece que não tem uma carteira digital criada ainda.',
    noIdentities:
      'Parece que não guardou nenhum documento ID na sua carteira digital ainda.',
    noComp:
      'Este browser não é compativel com o TSP WalliD para a Docusign. Para continuar, por favor transfira o Google Chrome ou outro browser compativél.',
  },

  welcome: {
    title: 'Bem-vindo à WalliD’s TSP para a DocuSign',
    text1:
      'Foi-lhe enviado um documento para assinar de forma legalmente vinculativa.',
    text2:
      "Vai precisar de fazer download da <span style='font-weight:700'> carteira digital MyWalliD  </span> e <span style='font-weight:700'> um documento de ID válido guardado nela </span> para completar o processo de assinatura e pode fazê-lo nuns breves instantes com a WalliD.",
    entities: [
      'ID guardado na carteira digital',
      'Nenhum ID guardado na carteira digital',
    ],
    text3: [
      'Se ainda não guardou o seu documento de identificação na sua carteira Ethtereum, faça-o por favor no ',
      ' site da WalliD',
      'e volte para esta página para continuar a sua assinatura.',
    ],
    terms: [
      'Por favor aceite os termos e condições da',
      ' WalliD TSP DocuSign',
    ],
  },
  status: {
    noPlugin: {
      msg: 'Sem carteira digital',
      color: '#e95e5e',
      error: 'Parece que não tem uma carteira digital criada ainda.',
    },
    noWallet: {
      msg: 'Carteira digital não configurada',
      color: '#e95e5e',
      error: 'Parece que não tem a sua carteira digital configurada ainda',
    },
    noIdStored: {
      msg: 'Nenhum ID guardado na carteira digital',
      color: '#e95e5e',
      error:
        'Parece que não guardou nenhum documento ID na sua carteira digital ainda.',
    },
    idStored: {
      msg: 'ID guardado na carteira digital',
      color: '#00e284',
    },
    lockedWallet: {
      msg: 'Carteira Bloqueada ',
      color: '#f79520',
      error:
        'Não está conectado à sua carteira. Faça login na sua carteira no pop-up apresentado pela sua carteira digital.',
    },
    walletConnected: {
      msg: 'Carteira conectada',
      color: '#00e284',
    },
  },
  step: {
    1: 'Forneça a sua Identidade',
    2: 'Decifre os seus dados',
    3: 'Verifique os seus dados',
  },
  identity: {
    title: 'Forneça a sua Identidade',
    label: 'Selecione o documento de Identificação:',
    placeholder: 'Selecione uma identidade válida',
    confirm: [
      'Autorize a partilha dos seus dados',
      'Autorize a partilha dos dados do seu documento de ID, clicando no botão “sign” do pop-up apresentado pela sua carteira.',
    ],
    loading: ' A recolher os seus dados de ID da sua carteira',
    another: 'Quer utilizar outro ID para assinar este documento? Aceda a ',
  },
  decrypt: {
    title: 'Passo 2 - Decifre os seus dados',
    data: 'Os seus dados encriptados',
    text: [
      'Este é o seu documento de Identificação criptografado com a palavra-passe que definiu no site ',
      'WalliD.io',
      'ao armazená-lo na blockchain. Por favor desencripte os seus dados preenchendo o campo abaixo com a sua palavra-passe:',
    ],
    password: [
      'Palavra-passe',
      'A sua palavra-passe deverá ter pelo menos 6 caracteres',
    ],
    disclaimer: [
      'Aviso',
      'A compilação atual do Metamask não suporta os recursos que criptografam dados com as chaves privadas dos utilizadores. Estará disponível em breve. Pode criptografar os seus dados de ID com uma password à sua escolha',
      'ação recomendada',
      'Caso contrário, poderá optar por permitir que a WalliD criptografe os seus dados de ID com uma senha padrão',
      'não recomendamos esta ação',
    ],
  },
  verify: {
    title: 'Verifique os seus dados e assine o documento',
    data: 'Os seu documento de ID:',
  },
  sign: {
    title: 'A sua ID foi verificada com sucesso',
    text1:
      'Os seus atributos de ID e o seu Certificado Digital foram verificados com sucesso pela sua Autoridade Certificadora.',
    text2:
      'A WalliD TSP DocuSign irá assinar o seu documento com o seu Certificado Digital após clicar no botão “Assinar documento”.',
  },
  successfull: {
    title: 'O seu documento foi assinado com sucesso!',
    text1: [
      'O envelope ',
      'com os documentos: ',
      ' foi assinado com sucesso com certificado do WalliD TSP para a DocuSign',
    ],
    text2: [
      'Após todas as partes interessadas assinarem o documento, poderá validar o documento com as assinaturas certificadas em ',
      'WalliD TSP para a DocuSign',
    ],
  },
  button: {
    begin: 'CONTINUAR',
    download: 'Download Chrome',
    provide: 'FORNECER',
    decrypt: 'DECIFRAR',
    verify: 'VERIFICAR',
    sign: 'ASSINAR DOCUMENTO',
    back: 'VOLTAR',
    cancel: 'CANCELAR',
    store: 'GUARDAR ID NA CARTEIRA',
    plugin: 'COMEÇAR',
  },
};
